import {Component, OnInit, Input} from '@angular/core';
import {Detalhamento} from '../detalhamento';

@Component({
    selector: 'store-produto-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    @Input()
    public detalhamento: Detalhamento;

    public imageMap: any[];

    constructor() {
    }

    ngOnInit() {
        /** TODO - O if deve ser removido assim que todas as imagens forem migradas para o novo bucket
         */
        if (this.getEhNovoBucket(this.detalhamento.imagem)) {
            this.imageMap = [
                this.getNameImagem('_small', this.detalhamento.imagem),
                this.getNameImagem('_medium', this.detalhamento.imagem) + ' 1.5x',
                this.getNameImagem('_large', this.detalhamento.imagem) + ' 2x',
            ];
        } else {
            this.imageMap = [this.detalhamento.imagem];
        }

    }

    getNameImagem(size: string, image: string) {
        return image.replace('/imagens/', '/imagens-resize/').replace('_origin', size);
    }

    getEhNovoBucket(imagem) {
        return imagem.includes('plat-s3-store-betha-cloud');
    }

    scrollToElement($element: string): void {
        document.getElementById($element).scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
    }

}
